import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { LoginReducer, LoginState } from '../../access/login/state/login.reducer';
import { environment } from '../../../environments/environment';

export interface AppState {
  login: LoginState;
}

export const reducers: ActionReducerMap<AppState> = {
  login: LoginReducer,
};

export const metaReducers: MetaReducer<AppState>[] = !environment.production ? [] : [];
